// src/utils/notify.js
import { toast } from 'react-toastify';

const notify = {
  success: (title, message = '') => {
    toast.success(message ? `${title}: ${message}` : title, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },

  error: (title, message = '') => {
    toast.error(message ? `${title}: ${message}` : title, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },

  warning: (title, message = '') => {
    toast.warning(message ? `${title}: ${message}` : title, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },

  info: (title, message = '') => {
    toast(message ? `${title}: ${message}` : title, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      icon: 'ℹ️'
    });
  },

  custom: (content, options = {}) => {
    toast(content, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options
    });
  }
};

export default notify;